export const en = {
  // Dashboard Header
  companyName: "Kochi Metro Rail Limited",
  systemTitle: "ML-Powered Train Induction Planning System",
  platformTitle: "ADVANCED OPERATIONS MANAGEMENT PLATFORM",
  systemOnline: "System Online",
  iotActive: "IoT Active",
  lastUpdated: "Last Updated",
  
  // Navigation
  dashboard: "Dashboard",
  schedule: "Schedule",
  alerts: "Alerts",
  scheduleTrainInduction: "Schedule Train Induction",
  selectAndDeployTrains: "Select and deploy trains for service",
  settings: "Settings",
  userSettings: "User Settings",
  systemConfiguration: "System Configuration",
  securityPermissions: "Security & Permissions",
  appearance: "Appearance",
  notifications: "Notifications",
  unread: "unread",
  markAllAsRead: "Mark all as read",
  
  // System Status
  systemStatus: "System Status",
  available: "Available",
  maintenance: "Maintenance",
  violations: "Violations",
  total: "Total",
  avgScore: "Avg Score",
  avgMileage: "Avg Mileage",
  topPerformer: "Top Performer",
  brandingIssues: "Branding Issues",
  
  // Train Table
  trainInductionList: "Train Ranked Induction List",
  selectedTrains: "selected",
  availableTrains: "available trains",
  rank: "Rank",
  trainId: "Train ID",
  status: "Status",
  score: "Score",
  stablingBay: "Stabling Bay",
  brandingPriority: "Branding Priority",
  mileage: "Mileage",
  lastCleaned: "Last Cleaned",
  deployable: "Deployable",
  
  // Selection Controls
  selectedTrainsCount: "SELECTED TRAINS",
  availableCount: "AVAILABLE",
  clearAll: "CLEAR ALL",
  confirmAnalytics: "CREATE SCHEDULE",
  
  // Buttons
  rerunSimulation: "RE-RUN SIMULATION",
  exportCsv: "EXPORT CSV",
  
  // Alerts
  systemAlerts: "System Alerts",
  monitoringNotifications: "Monitoring and notifications",
  noAlerts: "No alerts",
  allSystemsRunning: "All systems are running smoothly",
  noAlertsType: "No {type} alerts at this time",
  
  // Alert Types
  all: "All",
  critical: "Critical",
  warning: "Warning",
  info: "Info",
  
  // Language Switcher
  switchToMalayalam: "Switch to Malayalam",
  switchToEnglish: "Switch to English",
  switchToHindi: "Switch to Hindi",

  // Visualization
  showCharts: "Show Charts",
  hideCharts: "Hide Charts",
  dataVisualization: "Data Visualization",
  fleetStatusDistribution: "Fleet Status Distribution",
  performanceOverview: "Performance Overview",
  performanceTrends: "Performance Trends",
  totalFleet: "Total Fleet",
  readyForDeployment: "Ready for Deployment",
  systemEfficiency: "System Efficiency",
  activeViolations: "Active Violations",
  systemInsights: "System Insights",
  
  // Additional System Status
  service: "Service",
  efficiency: "Efficiency",
  cost: "Cost",
  reliability: "Reliability",
  branding: "Branding",
  shortfall: "Shortfall",
  
  // Alerts Page
  systemAlerts: "System Alerts",
  monitoringNotifications: "Monitoring and notifications",
  loadingAlerts: "Loading alerts...",
  fetchingNotifications: "Fetching latest system notifications",
  noAlerts: "No alerts",
  allSystemsRunning: "All systems are running smoothly",
  noFilteredAlerts: "No {filter} alerts at this time",
  ongoing: "Ongoing",
  completed: "Completed",
  
  // Selected Trains Dashboard
  selectedTrainsDashboard: "Selected Trains Dashboard",
  deploymentReady: "Deployment Ready",
  trainsRankedByPerformance: "trains ranked by performance",
  readyForDeployment: "Ready for deployment",
  selectionConfirmed: "Selection Confirmed",
  selectedTrainsForDeployment: "Selected Trains for Deployment (Ranked by Performance)",
  totalMileage: "Total Mileage",
  
  // Deployment Success Page
  deploymentSuccess: "Deployment Success",
  trainDeploymentCompleted: "Train deployment completed successfully",
  deploymentSuccessful: "Deployment Successful!",
  allSelectedTrainsDeployed: "All selected trains have been successfully deployed",
  trainsDeployed: "Trains Deployed",
  successRate: "Success Rate",
  crewsNotified: "Crews Notified",
  crewNotificationsSent: "Crew Notifications Sent",
  allThreeCrewsNotified: "All three crews have been notified",
  deploymentComplete: "Deployment Complete",
  allTrainsSuccessfullyDeployed: "All {count} trains successfully deployed",
  viewDashboard: "View Dashboard",
  
  // Dashboard — Deployed trains
  currentlyDeployedTrains: "Currently Deployed Trains",
  trainsInService: "trains in service",
  manageSchedule: "MANAGE SCHEDULE",
  
  // Button Labels
  modifySelection: "MODIFY SELECTION",
  deployAll: "DEPLOY ALL",
  
  // Additional Missing Translations
  selectAllAvailable: "SELECT ALL AVAILABLE",
  success: "Success",
  trainDeployedSuccessfully: "Train deployed successfully!",
  analyzingSystemMetrics: "Analyzing system metrics...",
  systemInsights: "System Insights",
  systemInsightsAnalytics: "System Insights & Analytics",
  insightsGenerated: "insights generated",
  available: "Available",
  efficiency: "Efficiency",
  maintenance: "Maintenance",
  violations: "Violations",
  totalMileage: "Total Mileage",
  estimatedCost: "Est. Cost",
  co2Footprint: "CO2 Footprint",
  performanceTrendAnalysis: "Performance Trend Analysis",
  performanceVisualization: "Performance visualization would be rendered here",
  chartIntegration: "Integration with Chart.js or similar library",
  high: "HIGH",
  medium: "MEDIUM",
  low: "LOW",
  confidence: "confidence",
  impact: "impact",
  retry: "Retry",
  loading: "Loading",
  error: "Error",
  rank: "RANK",
  trainId: "TRAIN ID",
  status: "STATUS",
  score: "SCORE",
  stablingBay: "STABLING BAY",
  brandingPriority: "BRANDING PRIORITY",
  mileage: "MILEAGE",
  lastCleaned: "LAST CLEANED",
  deployable: "DEPLOYABLE"
};
